require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
module.exports = require('../modules/$.core').Map;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/map.js
 ** module id = 527
 ** module chunks = 0
 **/